import { render, staticRenderFns } from "./RecipesZeroNote.vue?vue&type=template&id=588e63db"
import script from "./RecipesZeroNote.vue?vue&type=script&lang=js"
export * from "./RecipesZeroNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports